import { useState } from 'react';
import { cn } from '@/lib/utils';

/** Desde cuántas letras un texto se ofrece con «Ver completo» (criterio simple: ~3 líneas de la celda). */
export const LARGO_PARA_VER_COMPLETO = 150;

/**
 * Un texto de celda cortado a 3 líneas. Si es largo, un botón lo abre y lo cierra
 * (el `title` solo no sirve en táctil, teclado ni lector de pantalla). El tope de
 * ancho (320 px) va en este contenedor y no en el `<td>`: en una tabla, `max-width`
 * de la celda no limita (la tabla le reparte el sobrante; medido 462 px a 2.160 px).
 */
export function TextoRecortable({ texto, className }: { texto: string; className?: string }) {
  const [abierto, setAbierto] = useState(false);
  const largo = texto.length > LARGO_PARA_VER_COMPLETO;
  return (
    <div className="max-w-xs">
      <div
        title={texto}
        className={cn(!abierto && 'line-clamp-3', '[overflow-wrap:anywhere]', className)}
      >
        {texto}
      </div>
      {largo && (
        <button
          type="button"
          aria-expanded={abierto}
          onClick={() => setAbierto((a) => !a)}
          className="text-xs font-medium text-primary underline-offset-2 hover:underline"
        >
          {abierto ? 'Ver menos' : 'Ver completo'}
        </button>
      )}
    </div>
  );
}
